<template>

  <b-modal id="modal" ref="modal" centered scrollable hide-header-close
           title="اضافه کردن آیتم به منو" header-bg-variant="dark"
           header-text-variant="light" @ok="onSubmit" @cancel="resetForm">

    <form @submit.stop.prevent="onSubmit">

      <form-group :validations="$v.newItem.name">
        <div slot-scope="{ errors, invalid }">
          <b-form-input type="text" class="m-1" v-model="newItem.name" placeholder="عنوان آیتم"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group :validations="$v.newItem.url">
        <div slot-scope="{ errors, invalid }">
          <b-form-input type="url" class="m-1" v-model="newItem.url" placeholder="آدرس اینترنتی"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>


      <b-row class="d-flex flex-row justify-content-right mr-2 align-items-right">
        <span class="">آیکون: </span>
        <b-icon class="mx-2" :icon="newItem.icon_class"></b-icon>
      </b-row>


      <icon-picker @icon="setIcon" />

      <form-group :validations="$v.newItem.color">
        <div slot-scope="{ errors, invalid }">
          <b-form-input type="color" value="" class="m-1" v-model="newItem.color"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <b-form-select v-model="newItem.parent_id" :options="makeParentOptions"/>

    </form>

    <template #modal-footer="{ ok, cancel}">
      <b-row class="d-flex flex-row justify-content-around w-100">
        <b-button size="md" variant="success" @click="ok()">
          اضافه کردن آیتم
        </b-button>
        <b-button size="md" variant="danger" @click="cancel()">
          انصراف
        </b-button>
      </b-row>
    </template>
  </b-modal>

</template>

<script>
import {flatMenu} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Menu'
import FormGroup from "../../validator/FormGroup";
import {required, url} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import IconPicker from "../menu/IconPicker";

export default {
  name: "NewItemModalForm",
  components: {FormGroup, FormErrorsManager, IconPicker},
  props: ['parentItems'],
  data() {
    return {
      newItem: {
        menu_id: this.$route.params.id,
        status: false,
        target: '_self',
        order: 17,
        name: '',
        url: '',
        icon_class: '',
        parent_id: null,
        color: '#FFFFFF'
      },
    }
  },
  validations: {
    newItem: {
      name: {required},
      url: {required, url},
      color: {required},
    }
  },
  computed: {
    makeParentOptions() {
      let items = flatMenu(this.$store.getters["Menu/getMenuItems"])
      let options = []
      options.push({text: 'هیچکدام', value: null})
      for (let i in items) {
        options.push({text: items[i].name, value: parseInt(items[i].id)})
      }
      return options
    },
  },
  methods: {
    resetForm() {
      this.newItem = {
        menu_id: this.$route.params.id,
        status: false,
        target: '_self',
        order: 17,
        name: '',
        url: '',
        icon_class: '',
        parent_id: null,
        color: '#FFFFFF'
      }
    },
    checkParent() {
      if (this.newItem.parent_id === null) {
        delete this.newItem.parent_id
      } else {
        console.log(this.newItem.parent_id)
        this.newItem.parent_id = parseInt(this.newItem.parent_id)
      }
    },
    handleOk() {
      this.checkParent()
      this.$store.dispatch("Menu/createItem", this.newItem).then(res => {
        this.resetForm()
      })
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.handleOk()
        this.$nextTick(() => {
          this.$bvModal.hide('modal')
        })
      }
    },
    setIcon(value) {
      this.newItem.icon_class = value
    }
  }
}
</script>

<style scoped>

</style>